import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-quality-keeper-answer',
  templateUrl: './quality-keeper-answer.component.html',
  styleUrls: ['./quality-keeper-answer.component.scss'],
  standalone: false,
})
export class QualityKeeperAnswerComponent {
}
